// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sigmet-airmet-identifier.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sigmet-airmet-identifier/sigmet-airmet-identifier.js';
import g1 from '../lessons/meteorology/sigmet-airmet-identifier/sigmet-airmet-wmo-heading.js';

mount([g0, g1]);
